import React from 'react'

import Image  from '@Pure/Image'
import Link   from '@Pure/Link'
import Logo   from '@Pure/Logo'

import bemit from '@function/bemit'

import { getOnlineType } from '@root/utility'

const { app } = window;

export default function HomeProductSlideCard ({ product, ...props })
{
	let thumbnail;

	if (product.images?.[0]?.url)
	{
		thumbnail = product.images[0].url;
	}
	else if (product._artist?.images?.[0]?.url)
	{
		thumbnail = product._artist.images[0].url;
	}

	if (thumbnail)
	{
		thumbnail =
		(
			<Image className="c-model-preview__img" src={ thumbnail } />
		);
	}
	else
	{
		thumbnail =
		(
			<Logo className="c-model-preview__img default" type="svg"
				synergies={ true }
			/>
		);
	}

	let name = app.getTruncatedText(product.name, 60).toUpperCase();

	const online_type = getOnlineType(product.online_type);

	let output =
	(
		<div className={ bemit('c-model-preview-item', ['product', 'slider']) }
			key={ product.id }>

			<div className="c-model-preview c-model-preview--home">

				{
					online_type ?
					(
						<Link className="c-model-preview__online-type"
							href={ '/accueil/catalogue/' + product.id }>
							{ online_type }
						</Link>
					)
					: undefined
				}

				<div className="c-model-preview__thumb">
					<Link className="c-model-preview__thumb-link"
						href={ '/accueil/catalogue/' + product.id }>
						{ thumbnail }
					</Link>
				</div>

				<div className="c-model-preview__content">

					<h2 className="c-model-preview__title">
						<Link href={ '/accueil/catalogue/' + product.id }
							className="c-model-preview__title-link">
							{ name }
						</Link>
					</h2>

					<div className="c-model-preview__infos">

						<div className="c-model-preview__buttons">

							<Link href={ '/accueil/catalogue/' + product.id }
								className="c-model-preview__link">
								<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
									<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
								</svg>Fiche produit
							</Link>

						</div>

					</div>

				</div>

			</div>

		</div>
	);

	return output;
}